import homeImage from './homeimage.png';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Welcome to Xuan's Home Page
        </p>
        <img src={homeImage} className="App-logo" alt="homeImage" />
      </header>
      <footer className="App-footer">
        © Xuan Inc., All Rights Reserved, 2025
      </footer>
    </div>
  );
}

export default App;
